// .js-movie-start のクリックで、同じ .c-movie 内の .c-movie__embed に
// YouTube iframe を埋め込み、再生開始。
// 同時に同じカード内のサムネと再生ボタンを非表示にする。
// YouTube ID は .c-movie__embed の data-youtube-id から読む。
// 1 ページに複数の .c-movie があってもそれぞれ独立して動く。
export default () => {
  document.querySelectorAll('.js-movie-start').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      // 同じカード内に閉じてターゲットを探す
      const wrapper = trigger.closest('.c-movie');
      if (!wrapper) return;

      const container = wrapper.querySelector('.c-movie__embed');
      if (!container) return;

      const youtubeId = container.dataset.youtubeId;
      if (!youtubeId) return;

      // 二重起動防止
      if (container.dataset.movieStarted === '1') return;
      container.dataset.movieStarted = '1';

      const iframe = document.createElement('iframe');
      iframe.src =
        `https://www.youtube.com/embed/${encodeURIComponent(youtubeId)}` +
        `?autoplay=1&rel=0&playsinline=1`;
      iframe.title = 'YouTube';
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      );
      iframe.setAttribute('allowfullscreen', '');

      container.appendChild(iframe);

      // サムネ + 再生ボタンを非表示 (同じカード内に限定)
      wrapper
        .querySelectorAll('.p-top-movie__thumb, .c-movie-play')
        .forEach((el) => {
          el.style.display = 'none';
        });
    });
  });
};
